import { render, staticRenderFns } from "./PermissionSubmit.vue?vue&type=template&id=91c53112"
import script from "./PermissionSubmit.vue?vue&type=script&lang=js"
export * from "./PermissionSubmit.vue?vue&type=script&lang=js"
import style0 from "./PermissionSubmit.vue?vue&type=style&index=0&id=91c53112&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91c53112')) {
      api.createRecord('91c53112', component.options)
    } else {
      api.reload('91c53112', component.options)
    }
    module.hot.accept("./PermissionSubmit.vue?vue&type=template&id=91c53112", function () {
      api.rerender('91c53112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PermissionSubmit.vue"
export default component.exports